export default class Video {
  constructor() {
    // Video
    const videos = document.querySelectorAll('.video-item');
    if (videos.length > 0) {
      videos.forEach((video) => {
        if (video.querySelector('.video').classList.contains('youtube')) {
          this.youtubePlayer(video);
        } else {
          this.htmlPlayer(video);
        }
      });
    }
  }

  htmlPlayer(element) {
    const video = element.querySelector('.video video');
    this.managePoster(element, video);
  }

  youtubePlayer(element) {
    window.YT.ready(function() {
      const player = new YT.Player(element.querySelector('.video .player'), {
        height: '360',
        width: '640',
        videoId: element.querySelector('.video .player').dataset.id,
      });

      const playBtn = element.querySelector('.video .poster');
      if (playBtn) {
        playBtn.addEventListener('click', () => {
          playBtn.style.display = 'none';
          player.playVideo();
        });
      }
    });
  }

  managePoster(element, player) {
    const playBtn = element.querySelector('.video .poster');
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        playBtn.style.display = 'none';
        player.play();
      });
    }
  }
}